var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphonesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1192_20848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.89775 12.3477H5.30879C4.80763 12.3477 4.40137 12.7539 4.40137 13.2551V21.1833C4.40137 21.6844 4.80763 22.0907 5.30879 22.0907H6.89775C7.3989 22.0907 7.80517 21.6844 7.80517 21.1833V13.2551C7.80517 12.7539 7.3989 12.3477 6.89775 12.3477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.98758 13.6738H2.87409C2.51528 13.6738 2.22168 13.9674 2.22168 14.3262V20.1121C2.22168 20.4709 2.51528 20.7645 2.87409 20.7645H3.98758V13.6738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80748 19.9279C1.76662 19.9327 1.72537 19.9352 1.68374 19.9352C0.753785 19.9352 0 18.7193 0 17.2195C0 15.7197 0.753785 14.5039 1.68374 14.5039C1.72537 14.5039 1.76662 14.5064 1.80748 14.5112C1.84834 14.516 1.80748 19.9279 1.80748 19.9279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6917 12.3477H17.1027C16.6016 12.3477 16.1953 12.7539 16.1953 13.2551V21.1833C16.1953 21.6844 16.6016 22.0907 17.1027 22.0907H18.6917C19.1928 22.0907 19.5991 21.6844 19.5991 21.1833V13.2551C19.5991 12.7539 19.1928 12.3477 18.6917 12.3477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0132 20.7645H21.1267C21.4855 20.7645 21.7791 20.4709 21.7791 20.1121V14.3262C21.7791 13.9674 21.4855 13.6738 21.1267 13.6738H20.0132V20.7645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1929 19.9279C22.234 19.9327 22.2753 19.9352 22.3166 19.9352C23.2466 19.9352 24.0004 18.7194 24.0004 17.2195C24.0004 15.7198 23.2466 14.5039 22.3166 14.5039C22.275 14.5039 22.2337 14.5064 22.1929 14.5112V19.9279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.05509 6.29141C7.57052 4.42564 9.6577 3.27162 11.9573 3.27162C14.2568 3.27162 16.3439 4.42564 17.8594 6.29141C19.3165 8.08533 20.2464 10.5357 20.3388 13.2602H21.1258C21.3037 13.2602 21.4716 13.3042 21.6193 13.3818C21.5095 10.3348 20.4631 7.41863 18.8262 5.40331C17.0733 3.24505 14.645 1.91016 11.9573 1.91016C9.26943 1.91016 6.84121 3.24505 5.08826 5.40331C3.46642 7.40014 2.42396 10.3978 2.29834 13.4292C2.46438 13.3223 2.66175 13.2602 2.87319 13.2602H3.57571C3.66816 10.5357 4.59806 8.08533 6.05509 6.29141Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1192_20848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphonesIcon);
export default __webpack_public_path__ + "static/media/headphones-icon.617d68f1372b7078b62244449f24c3d1.svg";
export { ForwardRef as ReactComponent };